<template>
  <v-app id="inspire">
    <!-- <v-banner single-line>
      This is a demo instance - changes will not be persisted.
    </v-banner> -->

    <v-app-bar app color="white" flat>
      <v-img class="hidden-sm-and-down" max-height="80" max-width="80" contain src="./assets/logo.svg">
      </v-img>

      <v-tabs centered hide-slider class="ml-n9" color="grey darken-1">
        <v-tab key="dashboard" to="/" active-class="text-decoration-underline font-weight-bold">
          <v-badge color="red" :content="notif_count"> Dashboard </v-badge>
        </v-tab>
        <v-tab key="assess" to="/assess" active-class="text-decoration-underline font-weight-bold"> Systems </v-tab>
        <v-tab key="new" to="/new" active-class="text-decoration-underline font-weight-bold"> Scan </v-tab>
      </v-tabs>

      <v-avatar
        class="hidden-sm-and-down"
        color="grey darken-1 shrink"
        size="32"
      ></v-avatar>
    </v-app-bar>

    <v-main class="grey lighten-3">
      <router-view />
      <!-- <v-fab-transition>
        <v-btn
          v-show="!hidden"
          color="pink"
          dark
          absolute
          bottom
          right
          fab
          to="/new"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-fab-transition> -->
    </v-main>
    <v-footer app padless dark>
      <v-col class="text-center" cols="12">
        This is a demo instance - some functionality has been removed. This demo uses Google Analytics with IP anonymisation.
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    notif_count: 2,
    links: [
      { name: "Dashboard", route: "/" },
      {
        name: "Assessments",
        route: "/assess",
      },
      {
        name: "Scan",
        route: "/new",
      },
    ],
  }),
};
</script>
